import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { connect } from "react-redux";
import { IMarketActionDispatches, mapMarketDispatchToProps } from "../../redux/actions/market";
import { IMarketState, mapMarketStateToProps } from "../../redux/reducers/market";
import UserRoleContent from "../auth/permissions/UserRoleContent";
import UIModal from "../ui/UIModal";
import ImageGalleryPaging from "./ImageGalleryPaging";
import DescriptionText from "../../laco-common/components/DescriptionText";
import { IEvent } from "../../laco-common/base/models/event";
import { renderGroup } from "./Messages";
import { getDateDisplay } from "../../utils/date-utils";
import { displayDateTime2 } from "../../laco-common/helpers";
import { locationLinkDisplay } from "../events/EventsCalendar";
import "./AdDetail.scss";

type EventDetailProps = {
	onClose: () => any;
	onGoToEvent: (e, ev: IEvent) => any;
};

type EventDetailState = {
	msg: IEvent;
	showSellerInfo: boolean;
};

class MessageDetail extends Component<
	IMarketActionDispatches & IMarketState & EventDetailProps & RouteComponentProps,
	EventDetailState
> {
	state = {
		msg: null,
		showSellerInfo: false,
	};

	componentDidMount() {
		this.setMessageDetailView();
	}

	componentWillUnmount() {
		this.setState({ msg: null });
	}

	componentDidUpdate(prevProps: EventDetailProps & RouteComponentProps, prevState: EventDetailState, snapshot) {
		if (
			prevProps.location.pathname !== this.props.location.pathname ||
			(prevProps.location.pathname === this.props.location.pathname && prevState.msg === null)
		) {
			this.setMessageDetailView();
		}
	}

	async setMessageDetailView(messages: IEvent[] = this.props.messages) {
		const pathSegments: string[] = this.props.location.pathname.split("/");
		if (pathSegments.length < 3) {
			this.setState({ msg: null });
			return;
		}
		const id: string = pathSegments[2];
		const msg: IEvent = messages.find((m: IEvent) => m.id === id);
		console.log("setMessageDetailView() id:", id, msg);
		this.setState({ msg: msg });
	}

	render() {
		if (!this.state.msg) return null;
		const msg: IEvent = this.state.msg;
		console.log("dana msg.media:", msg.media);
		return (
			<UserRoleContent roles={["admin", "user"]}>
				<UIModal
					title={msg.title}
					pageTitle={msg.title}
					open={!!msg}
					onClose={() => {
						this.setState({ msg: null });
						this.props.onClose();
					}}
					showCloseIcon={true}
					noPadding={true}
					noContainer={true}
					className="image-fullscreen-overlay ad-detail-modal"
					contentClassName="ui-modal-content-fullscreen"
				>
					<div className="ad-detail-container d-flex flex-column flex-lg-row justify-content-between">
						<ImageGalleryPaging images={msg.media} />
						<div className="ad-detail-section mt-4">
							<h2>
								{msg.link ? (
									<a href={msg.link} target="_blank">
										{msg.title}
									</a>
								) : (
									msg.title
								)}
							</h2>
							{/* <h3 className="ad-price text-primary mb-1">price was here</h3> */}
							{msg.eventDate && (
								<>
									<div
										className="ad-price d-inline-flex align-items-center link underline"
										style={{
											padding: "3px 0px",
										}}
										onClick={(e) => {
											this.props.onGoToEvent(e, msg);
										}}
									>
										<i
											className="im im-date-o mr-1"
											style={{ fontSize: "15px", textDecoration: "none !important" }}
										></i>
										{displayDateTime2(msg.eventDate as number)}
									</div>
									{msg.eventLocation && (
										<UserRoleContent noAuthMessage={true}>
											{locationLinkDisplay(msg.eventLocation)}
										</UserRoleContent>
									)}
								</>
							)}

							<h4 className="ad-date">
								{getDateDisplay(new Date(msg.created_at), null)} {renderGroup.call(this, msg)}
							</h4>
							{!!msg.description && (
								<div className="description mt-2">
									<h5 className="mb-2-5 font-weight-bold">Description</h5>
									<DescriptionText text={msg.description} />
								</div>
							)}
							{!!msg.link && (
								<div className="mt-3">
									<a href={msg.link} target="_blank">
										{msg.link_text || msg.link}
									</a>
								</div>
							)}
						</div>
					</div>
				</UIModal>
			</UserRoleContent>
		);
	}
}

export default connect<IMarketState, IMarketActionDispatches, EventDetailProps>(
	mapMarketStateToProps,
	mapMarketDispatchToProps
)(withRouter(MessageDetail));
